module.exports = "<div class=\"loading-icon\"></div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/shared-module/widgets/loading/loading.component.html
// module id = ../../../../../src/app/shared-module/widgets/loading/loading.component.html
// module chunks = main